// @internal
export function isString(value) {
    return typeof value === 'string';
}
//# sourceMappingURL=isString.js.map